"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("../scss/main.scss");
var Tabs;
(function (Tabs) {
    const $labels = document.querySelectorAll('.tabs .tabs-nav label');
    $labels.forEach(($label) => {
        $label.removeEventListener('click', () => { });
        $label.addEventListener('click', () => {
            if (!$label.classList.contains('is-active')) {
                $label
                    .closest('.tabs-nav')
                    .querySelectorAll('label.is-active')
                    .forEach(($lbl) => {
                    $lbl.classList.remove('is-active');
                });
                $label.classList.add('is-active');
            }
        });
    });
})(Tabs || (Tabs = {}));
